import React, { useState, useEffect, useRef, useCallback } from "react";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Card, Form, Input, Button, Row, Col, Select, Spin, message, Checkbox, Upload, Skeleton, InputNumber } from "antd";
import { useSelector, useDispatch } from 'react-redux'
import { TagFilled, DownloadOutlined, CalendarFilled, DownOutlined, UpOutlined, CreditCardFilled, CloudUploadOutlined,MobileOutlined , BankOutlined, ExpandOutlined ,TeamOutlined, StarFilled, FileDoneOutlined, CheckCircleOutlined, MailFilled, QuestionCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Layout, Radio } from "antd";
import { Collapse } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { useLocation, Link } from "react-router-dom";
import { getBrand } from "../util/getLogo";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input'
import MercadoPagoBrick from '../components/MercadoPagoBrick'

import axios from '../util/Api';

import '../styles/kernel.scss'
import '../styles/course.scss'
import { setResponsive } from "../appRedux/actions/Responsive";
import { getUser } from "../appRedux/actions/Auth";
import NavBar from "../components/NavBarPublic";


import yapeImg from '../assets/images/yape.jpeg';
import logoNiubiz from '../assets/images/logo-niubiz.png';
import logosCards from '../assets/images/BANNER CABECERA.png';


import checkedSVG from '../assets/svg/checked.svg';
const { Panel } = Collapse;

const { Content, Footer } = Layout;
var elementStyles = {
    base: {
        color: '#666666',
        fontWeight: 400,
        fontFamily: "'Montserrat', sans-serif",
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        padding: '10px',
        placeholder: {
            color: '#999999'
        },
        autofill: {
            color: '#e39f48'
        }
    },
    invalid: {
        color: '#E25950',
        '::placeholder': {
            color: '#FFCCA5'
        }
    }
};

const InscriptionInner = () => {
    const brand = getBrand()
    const query = new URLSearchParams(useLocation().search)
    const id = query.get('id')
    const cartParam = query.get('cart')
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const responsive = useSelector(store => store.responsive.value)
    const authUser = useSelector(store => store.auth.authUser)
    const { executeRecaptcha } = useGoogleReCaptcha()

    const [checkTerms, setCheckTerms] = useState(false)
    const checkTermsRef = useRef(false)
    const [subtotal, setSubtotal] = useState(0)

    const [participantType, setParticipantType] = useState('PERSONA_NATURAL')
    const participantTypeRef = useRef('PERSONA_NATURAL')
    const coursesRef = useRef([])
    // Persona NATURAL
    const [namePerson, setNamePerson] = useState('')
    const namePersonRef = useRef('')
    const [lastName1, setLastName1] = useState('')
    const lastName1Ref = useRef('')
    const [lastName2, setLastName2] = useState('')
    const lastName2Ref = useRef('')
    const [typeDoc, setTypeDoc] = useState('')
    const typeDocRef = useRef('')
    const [nroDoc, setNroDoc] = useState('')
    const nroDocRef = useRef('')
    const [email, setEmail] = useState('')
    const emailRef = useRef('')
    const [phone, setPhone] = useState('+51')
    const phoneRef = useRef('+51')
    // EMPRESA
    const [companyRuc, setCompanyRuc] = useState('')
    const companyRucRef = useRef('')
    const [companyBusinessName, setCompanyBusinessName] = useState('')
    const companyBusinessNameRef = useRef('')
    const [companyEmail, setCompanyEmail] = useState('')
    const companyEmailRef = useRef('')
    const [companyContactPerson, setCompanyContactPerson] = useState('')
    const companyContactPersonRef = useRef('')
    const [companyPhone, setCompanyPhone] = useState('+51')
    const companyPhoneRef = useRef('+51')

    const [availableCourses, setAvailableCourses] = useState([])
    const [showMoreCoursesTable, setShowMoreCoursesTable] = useState(false)
    const [mobileStep, setMobileStep] = useState('datos')
    const [mobileShowCertInfo, setMobileShowCertInfo] = useState(false)

    const [typePayment, setTypePayment] = useState('')
    const [voucher, setVoucher] = useState('')
    const [saveSuccess, setSaveSuccess] = useState(0)
    const [saveSuccessData, setSaveSuccessData] = useState({})
    const [programmingData, setProgrammingData] = useState({})

    let RegexEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+$/;
    let RegexNumber = /^([0-9])*$/;
    let RegexOnlyLetters = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;

    const [session, setSession] = useState([])
    const [activePayment, setActivePayment] = useState(false)
    const [loading, setLoading] = useState(false)

    const [processingPayment, setProcessingPayment] = useState(false)
    const [processingMessage, setProcessingMessage] = useState('')

    const [nameNiubiz, setNameNiubiz] = useState('')
    const [lnameNiubiz, setLNameNiubiz] = useState('')
    const [emailNiubiz, setEmailNiubiz] = useState('')

    const [courses, setCourses] = useState([])
    const [coursesSeguriton, setCoursesSeguriton] = useState([])
    const [rulesSeguriton, setRulesSeguriton] = useState([])
    const [total, setTotal] = useState(0)
    const [discount, setDiscount] = useState('0.00')

    const [showForm, setShowForm] = useState(false)
    const [wayToPay, setWayToPay] = useState('')
    const [loadingCourse, setLoadingCourse] = useState(false)
    const [errorNiubiz, setErrorNiubiz] = useState(false)

    const MP_ERROR_MESSAGES = {
        cc_rejected_insufficient_amount: 'Fondos insuficientes. Verifique el saldo de su tarjeta.',
        cc_rejected_bad_filled_card_number: 'Número de tarjeta incorrecto. Verifique e intente nuevamente.',
        cc_rejected_bad_filled_date: 'Fecha de vencimiento incorrecta.',
        cc_rejected_bad_filled_security_code: 'Código de seguridad (CVV) incorrecto.',
        cc_rejected_bad_filled_other: 'Datos de tarjeta incorrectos. Verifique e intente nuevamente.',
        cc_rejected_call_for_authorize: 'Pago no autorizado. Contacte a su banco para habilitar la transacción.',
        cc_rejected_other_reason: 'Tarjeta rechazada. Intente con otra tarjeta o contacte a su banco.',
        cc_rejected_invalid_installments: 'Número de cuotas no permitido para esta tarjeta.',
        pending_contingency: 'Su pago está siendo procesado. Le notificaremos por correo en breve.',
        pending_review_manual: 'Su pago está en revisión. Le notificaremos por correo en breve.',
    }


    useEffect(() => {


        dispatch(setResponsive())
        dispatch(getUser())
        setTypePayment('')

        getCourse()



    }, [])

    const getSession = () => {

        axios.post('/external/niubiz/session', { amount: total }
        ).then(({ data }) => {
            setSession(data)
            // setActivePayment(true)
            setLoadingCourse(false)

        }).catch(function (error) {
            setLoadingCourse(false)

        })

    }




    const createForm = () => {
        window.cardNumber = window.payform.createElement('card-number', {
            style: elementStyles,
            placeholder: 'N° de Tarjeta'
        }, 'txtNumeroTarjeta');
        window.cardExpiry = window.payform.createElement('card-expiry', {
            style: elementStyles,
            placeholder: 'MM/AA'
        }, 'txtFechaVencimiento');
        window.cardCvv = window.payform.createElement('card-cvc', {
            style: elementStyles,
            placeholder: 'CVV'
        }, 'txtCvv');
        setShowForm(true)

    }

    const setConfigurationScriptLoaded = () => {


        var configuration = {
            sessionkey: session.sesionKey,
            channel: "web",
            merchantid: session.merchantId,
            purchasenumber: session.purchaseNumber,
            amount: session.amount,
            language: "es", // esto falta en su documentación de nibubiz
            merchantConfiguration: {
                recurrencyEnabled: false,
                tokenizationEnabled: false,
            },
            font: "https://fonts.googleapis.com/css?family=Montserrat:400&display=swap"
        };
        window.configuration = configuration
        window.payform.setConfiguration(configuration)
        createForm()
    }

    const addCustomPayScript = () => {
        return new Promise((resolve) => {
            if (window.payform) {
                resolve()
            } else {
                setShowForm(false)

                const script = document.createElement('script')
                script.id = 'niubiz_script'
                script.src = process.env.REACT_APP_NIUBIZ_JS
                script.async = true
                script.onload = () => setConfigurationScriptLoaded()
                document.head.appendChild(script)
                resolve()
            }

        })
    }

    const importFiles = async () => {
        try {
            await addCustomPayScript()
        } catch (error) {
            message.error(error)
            console.log('Error al cargar el script de pago', error)
        }
    }

    // descuento

    const getDiscountRate = (courseList) => {
        const distinctCourses = courseList.length
        const hasMultipleQty = courseList.some(c => parseInt(c.qty || 1) >= 2)

        if (distinctCourses >= 2) return 0.15
        if (distinctCourses === 1 && hasMultipleQty) return 0.10
        return 0
    }

    const recalculateTotal = (courseList) => {
        let subtotal = 0
        courseList.forEach((course) => {
            const unitPrice = parseFloat(course.price || 0)
            const qty = parseInt(course.qty || 1, 10)
            subtotal += unitPrice * qty
        })
        const rate = getDiscountRate(courseList)
        const discountAmount = subtotal * rate
        setTotal(subtotal - discountAmount)
        setDiscount(discountAmount.toFixed(2))
        setSubtotal(subtotal)
    }
    //

    const updateCourseQty = (index, value) => {
        const qty = Math.max(1, parseInt(value || 1, 10))
        const updatedCourses = [...courses]
        updatedCourses[index] = { ...updatedCourses[index], qty }
        setCourses(updatedCourses)
        coursesRef.current = updatedCourses 
        recalculateTotal(updatedCourses)
    }

    const onChangeParticipantType = (value) => {
        setParticipantType(value)
        participantTypeRef.current = value

        if (value === 'PERSONA_NATURAL') {
            setCompanyRuc('')
            companyRucRef.current = ''
            setCompanyBusinessName('')
            companyBusinessNameRef.current = ''
            setCompanyEmail('')
            companyEmailRef.current = ''
            setCompanyContactPerson('')
            companyContactPersonRef.current = ''
            setCompanyPhone('+51')
            companyPhoneRef.current = '+51'
        }

        if (value === 'EMPRESA') {
            setTypeDoc('')
            typeDocRef.current = ''
            setNroDoc('')
            nroDocRef.current = ''
            setNamePerson('')
            namePersonRef.current = ''
            setLastName1('')
            lastName1Ref.current = ''
            setLastName2('')
            lastName2Ref.current = ''
            setEmail('')
            emailRef.current = ''
            setPhone('+51')
            phoneRef.current = '+51'
        }
    }

    const getAvailableCourses = (selectedCourses = []) => {
        axios.post(
            'https://apicursos.iteprevengo.com/api/external/courses/list',
            {
                text: '',
                modality: 'VIRTUAL',
                idCategory: 0
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(({ data }) => {
            const apiCourses = data.data || []

            const selectedIds = selectedCourses.map(c => Number(c.idProgramming))

            const filteredCourses = apiCourses
                .filter(course => !selectedIds.includes(Number(course.id)))
                .map(course => ({
                    idProgramming: course.id,
                    course_name: course.course_name,
                    price: course.participantPrice,
                    modality: 'VIRTUAL',
                    qty: 1,
                    duration: course.duration
                }))

            setAvailableCourses(filteredCourses)
        })
        .catch((error) => {
            console.log('Error obteniendo cursos disponibles:', error)
        })
    }

    // Función para añadir curso a tabla a pagar
    const addAvailableCourse = (course) => {
        const updatedCourses = [...courses, { ...course, qty: 1 }]
        setCourses(updatedCourses)
        coursesRef.current = updatedCourses 
        recalculateTotal(updatedCourses)
        const updatedAvailable = availableCourses.filter(
            c => Number(c.idProgramming) !== Number(course.idProgramming)
        )
        setAvailableCourses(updatedAvailable)
    }

    // Función para eliminar cursos seleccionados a comprar
    const removeSelectedCourse = (courseToRemove) => {
        if (courses.length <= 1) return
        const updatedCourses = courses.filter(
            c => Number(c.idProgramming) !== Number(courseToRemove.idProgramming)
        )
        setCourses(updatedCourses)
        coursesRef.current = updatedCourses 
        recalculateTotal(updatedCourses)
        const existsInAvailable = availableCourses.some(
            c => Number(c.idProgramming) === Number(courseToRemove.idProgramming)
        )
        if (!existsInAvailable) {
            setAvailableCourses([...availableCourses, { ...courseToRemove, qty: 1 }])
        }
    }

    useEffect(() => {
        if (session.sesionKey != undefined) {
            resetPayment()

        }


    }, [session])


    useEffect(() => {

    }, [courses, coursesSeguriton, total])


    const payVisa = () => {

        if (!checkTerms) {
            message.warning('Debe aceptar los términos y condiciones')
            return false;
        }


        if (nameNiubiz == '') {
            message.warning('Ingrese un nombre en el formulario NIUBIZ')
            return false;
        }
        if (lnameNiubiz == '') {
            message.warning('Ingrese sus apellidos en el formulario NIUBIZ')
            return false;
        }
        if (emailNiubiz == '') {
            message.warning('Ingrese un correo en el formulario NIUBIZ')
            return false;
        }

        if (!RegexEmail.test(emailNiubiz)) {
            message.warning('El correo ingresado en el formulario NIUBIZ no tiene el formato correcto')
            return false;


        }




        setLoading(true)
        var data = {
            name: nameNiubiz,
            lastName: lnameNiubiz,
            email: emailNiubiz,
            phoneNumber: '',
            currencyConversion: false,
            recurrence: false,
            alias: nameNiubiz
        }
        window.payform.createToken(
            [window.cardNumber, window.cardExpiry, window.cardCvv],
            data
        )
            .then(function (res) {



                save(res.transactionToken)
            })
            .catch((error) => {
                message.error(error)
                setLoading(false)
                getSession()


            });

    }

    const resetPayment = () => {

        let myPromise = new Promise(function (myResolve, myReject) {
            if (document.getElementById("niubiz_script")) {
                document.getElementById("niubiz_script").remove()

            }
            console.log('reset')
            //  document.head.getElementsByTagName("script")[0].remove()
            //  document.head.getElementsByTagName("script")[1].remove()


            setShowForm(false)

            document.getElementById('txtNumeroTarjeta').innerHTML = ''
            document.getElementById('txtFechaVencimiento').innerHTML = ''
            document.getElementById('txtCvv').innerHTML = ''


            myResolve();
            myReject();
        });

        myPromise.then(
            function (value) {
                console.log('reset')
                const script = document.createElement('script')
                script.id = 'niubiz_script'
                script.src = process.env.REACT_APP_NIUBIZ_JS
                script.async = true
                script.onload = () => setConfigurationScriptLoaded()
                document.head.appendChild(script)
            },
            function (error) { }
        );
    }


    const onMPSuccess = async (response) => {
        setProcessingPayment(true)
        setProcessingMessage('Ya casi terminamos, por favor no cierre la ventana.')
        await save()
        setProcessingPayment(false)
    }

    const onMPError = (error) => {
        const detail = error.detail || ''
        const userMessage = MP_ERROR_MESSAGES[detail] || null

        if (error.status === 'rejected') {
            message.error(userMessage || 'Pago rechazado. Verifique los datos de su tarjeta e intente nuevamente.')
        } else if (error.status === 'in_process' || error.status === 'pending') {
            message.warning(userMessage || 'Su pago está en revisión. Le notificaremos por correo.')
        } else {
            message.error('Hubo un error al procesar el pago. Intente nuevamente.')
        }

        console.error('MP Error:', error)
    }

    const getCourse = () => {

        // ── Flujo carrito:
        if (cartParam) {
            const ids = cartParam.split(',').map(Number).filter(Boolean)
            axios.post(
                'https://apicursos.iteprevengo.com/api/external/courses/list',
                { text: '', modality: 'VIRTUAL', idCategory: 0 },
                { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
            ).then(({ data }) => {
                const apiCourses = data.data || []
                const selected = apiCourses
                    .filter(c => ids.includes(Number(c.id)))
                    .map(c => ({
                        idProgramming: c.id,
                        course_name: c.course_name,
                        price: c.participantPrice,
                        modality: 'VIRTUAL',
                        qty: 1,
                        duration: c.duration || ''
                    }))
                setCourses(selected)
                coursesRef.current = selected
                recalculateTotal(selected)
                getAvailableCourses(selected)
            }).catch(err => console.log('Error cargando carrito:', err))
            return
        }

        // ── Flujo individual
        axios.get('/external/programming/' + id, {
            headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(({ data }) => {
            if (data.seguriton) {
                setCoursesSeguriton(data.courses)
                setRulesSeguriton(data.rules)
                setProgrammingData([{ participantPrice: '1' }])
            } else {
                let programming = data.programming
                const initialCourse = {
                    idProgramming: programming.idProgramming,
                    course_name: programming.course.name,
                    price: programming.participantPrice,
                    modality: programming.modality,
                    qty: 1,
                    duration: programming.course.duration || programming.duration || ''
                }
                setCourses([initialCourse])
                coursesRef.current = [initialCourse]
                setTotal(parseFloat(programming.participantPrice))
                setWayToPay(programming.waytopay)
                getAvailableCourses([initialCourse])
            }
        }).catch(err => console.log("Error****:", err))
    }

    const validate = () => {
        let $msg = ''

        if (courses.length == 0) {
            $msg = 'Seleccione al menos un curso'
        }

        if (!authUser) {
            if (participantTypeRef.current === '') {
                $msg = 'Seleccione un tipo de participante'
            }

            if (participantTypeRef.current === 'PERSONA_NATURAL') {
                if (!phoneRef.current || !isValidPhoneNumber(phoneRef.current)) {
                    $msg = 'Ingrese un celular válido'
                }
                if (emailRef.current == '') {
                    $msg = 'Ingrese un correo'
                }
                if (!RegexEmail.test(emailRef.current)) {
                    $msg = 'La dirección de email es incorrecta.'
                }
                if (lastName2Ref.current == '') {
                    $msg = 'Ingrese un apellido materno'
                }
                if (lastName1Ref.current == '') {
                    $msg = 'Ingrese un apellido paterno'
                }
                if (namePersonRef.current == '') {
                    $msg = 'Ingrese un nombre'
                }
                if (namePersonRef.current && !RegexOnlyLetters.test(namePersonRef.current)) {
                    $msg = 'El nombre solo debe contener letras'
                }
                if (lastName1Ref.current && !RegexOnlyLetters.test(lastName1Ref.current)) {
                    $msg = 'El apellido paterno solo debe contener letras'
                }
                if (lastName2Ref.current && !RegexOnlyLetters.test(lastName2Ref.current)) {
                    $msg = 'El apellido materno solo debe contener letras'
                }
                if (typeDocRef.current == '') {
                    $msg = 'Seleccione un tipo de documento'
                }
                if (typeDocRef.current == 'DNI') {
                    if (nroDocRef.current.length != 8) {
                        $msg = 'El número de documento debe tener 8 caracteres'
                    }
                    if (!RegexNumber.test(nroDocRef.current)) {
                        $msg = 'El número de documento solo debe contener números.'
                    }
                } else {
                    if (nroDocRef.current.length < 5 || nroDocRef.current.length > 12) {
                        $msg = 'El número de documento debe tener entre 5 y 12 caracteres'
                    }
                }
            }

            if (participantTypeRef.current === 'EMPRESA') {
                if (companyRucRef.current == '') {
                    $msg = 'Ingrese RUC'
                }
                if (companyRucRef.current.length != 11) {
                    $msg = 'El RUC debe tener 11 dígitos'
                }
                if (companyBusinessNameRef.current == '') {
                    $msg = 'Ingrese razón social'
                }
                if (companyEmailRef.current == '') {
                    $msg = 'Ingrese un correo de empresa'
                }
                if (!RegexEmail.test(companyEmailRef.current)) {
                    $msg = 'La dirección de email es incorrecta.'
                }
                if (companyContactPersonRef.current == '') {
                    $msg = 'Ingrese persona de contacto'
                }
                if (companyContactPersonRef.current && !RegexOnlyLetters.test(companyContactPersonRef.current)) {
                    $msg = 'La persona de contacto solo debe contener letras'
                }
                if (!companyPhoneRef.current || !isValidPhoneNumber(companyPhoneRef.current)) {
                    $msg = 'Ingrese un celular de contacto válido'
                }
            }
        }

        if (!checkTermsRef.current) {
            $msg = 'Debe aceptar los términos y condiciones'
        }

        if ($msg != '') {
            message.warning($msg)
        }

        return $msg
    }

    const validateDatos = () => {
        let $msg = ''
        if (courses.length === 0) $msg = 'Seleccione al menos un curso'
        if (!authUser) {
            if (participantTypeRef.current === '') $msg = 'Seleccione un tipo de participante'
            if (participantTypeRef.current === 'PERSONA_NATURAL') {
                if (!phoneRef.current || !isValidPhoneNumber(phoneRef.current)) $msg = 'Ingrese un celular válido'
                if (emailRef.current === '') $msg = 'Ingrese un correo'
                if (!RegexEmail.test(emailRef.current)) $msg = 'La dirección de email es incorrecta.'
                if (lastName2Ref.current === '') $msg = 'Ingrese un apellido materno'
                if (lastName1Ref.current === '') $msg = 'Ingrese un apellido paterno'
                if (namePersonRef.current === '') $msg = 'Ingrese un nombre'
                if (namePersonRef.current && !RegexOnlyLetters.test(namePersonRef.current)) $msg = 'El nombre solo debe contener letras'
                if (lastName1Ref.current && !RegexOnlyLetters.test(lastName1Ref.current)) $msg = 'El apellido paterno solo debe contener letras'
                if (lastName2Ref.current && !RegexOnlyLetters.test(lastName2Ref.current)) $msg = 'El apellido materno solo debe contener letras'
                if (typeDocRef.current === '') $msg = 'Seleccione un tipo de documento'
                if (typeDocRef.current === 'DNI') {
                    if (!RegexNumber.test(nroDocRef.current)) $msg = 'El número de documento solo debe contener números.'
                    if (nroDocRef.current.length !== 8) $msg = 'El número de documento debe tener 8 caracteres'
                } else if (nroDocRef.current.length < 5 || nroDocRef.current.length > 12) {
                    $msg = 'El número de documento debe tener entre 5 y 12 caracteres'
                }
            }
            if (participantTypeRef.current === 'EMPRESA') {
                if (companyPhoneRef.current === '') $msg = 'Ingrese celular de contacto'
                if (companyContactPersonRef.current === '') $msg = 'Ingrese persona de contacto'
                if (companyContactPersonRef.current && !RegexOnlyLetters.test(companyContactPersonRef.current)) $msg = 'La persona de contacto solo debe contener letras'
                if (!companyPhoneRef.current || !isValidPhoneNumber(companyPhoneRef.current)) $msg = 'Ingrese un celular de contacto válido'
                if (!RegexEmail.test(companyEmailRef.current)) $msg = 'La dirección de email es incorrecta.'
                if (companyEmailRef.current === '') $msg = 'Ingrese un correo de empresa'
                if (companyBusinessNameRef.current === '') $msg = 'Ingrese razón social'
                if (companyRucRef.current.length !== 11) $msg = 'El RUC debe tener 11 dígitos'
                if (companyRucRef.current === '') $msg = 'Ingrese RUC'
            }
        }
        if ($msg !== '') message.warning($msg)
        return $msg
    }

    // handleChangeTypeDocument
    function handleChangeTypeDocument(event) {
        setNroDoc('')
        nroDocRef.current = ''
        setTypeDoc(event)
        typeDocRef.current = event
    }

    // handleChangeClientDocument
    function handleChangeClientDocument(event) {
        const val = event.target.value.replace(/\D/, '')
        setNroDoc(val)
        nroDocRef.current = val
    }


    const save = async () => {
        if (loading) return

        if (!executeRecaptcha) {
            message.error('reCAPTCHA no está listo, intente de nuevo')
            return
        }

        const recaptchaToken = await executeRecaptcha('inscription_submit')

        const url = !authUser
            ? '/external/inscription/processVirtualInscription'
            : '/inscription/processVirtualInscription'

        const programmingsPayload = coursesRef.current.map(course => ({
            idProgramming: Number(course.idProgramming),
            qty: Math.max(1, Number(course.qty || 1))
        }))

        const request = {
            recaptchaToken,
            participantType: participantTypeRef.current,
            typeDoc: participantTypeRef.current === 'PERSONA_NATURAL' ? typeDocRef.current : '',
            nroDoc: participantTypeRef.current === 'PERSONA_NATURAL' ? nroDocRef.current : '',
            name: participantTypeRef.current === 'PERSONA_NATURAL' ? namePersonRef.current : '',
            lastName1: participantTypeRef.current === 'PERSONA_NATURAL' ? lastName1Ref.current : '',
            lastName2: participantTypeRef.current === 'PERSONA_NATURAL' ? lastName2Ref.current : '',
            email: participantTypeRef.current === 'PERSONA_NATURAL' ? emailRef.current : '',
            phone: participantTypeRef.current === 'PERSONA_NATURAL' ? phoneRef.current : '',
            companyRuc: participantTypeRef.current === 'EMPRESA' ? companyRucRef.current : '',
            companyBusinessName: participantTypeRef.current === 'EMPRESA' ? companyBusinessNameRef.current : '',
            companyEmail: participantTypeRef.current === 'EMPRESA' ? companyEmailRef.current : '',
            companyContactPerson: participantTypeRef.current === 'EMPRESA' ? companyContactPersonRef.current : '',
            companyPhone: participantTypeRef.current === 'EMPRESA' ? companyPhoneRef.current : '',
            paymentType: 'MERCADOPAGO',
            programmings: programmingsPayload
        }

        setLoading(true)

        try {
            const { data } = await axios.post(url, request)
            message.success(data.message)
            setSaveSuccess(1)
            setSaveSuccessData(data)
        } catch (error) {
            if (error.response) {
                message.error(error.response.data.message || 'Error al procesar')
            } else {
                message.error(error.message)
            }
        } finally {
            setLoading(false)
        }
    }

    const onChangePaymentMethod = e => {
        if (e == 'NIUBIZ') {
            getSession()
        }
        setVoucher('')
        setTypePayment(e)



    }

    const props_upload = {
        name: "file_to_upload",
        action: `${process.env.REACT_APP_API}/external/files/storage`,

        fileList: [],

        onChange(info) {
            console.log(info)

            if (info.file.status !== "uploading") {

            }
            if (info.file.status == 'done') {
                setVoucher(info.file.response)

                message.success(`${info.file.name} archivo subido correctamente`)


            } else if (info.file.status === "error") {
                message.error(`${info.file.name} hubo un error al subir el archivo.`)
            }


        },
        onRemove: file => {
            setVoucher()
        },
    }


    const uploadFile = (e) => {
        if(e.target.files[0]){
            let formData = new FormData();
            formData.append("file_to_upload", e.target.files[0]);
            axios.post(`${process.env.REACT_APP_API}/external/files/storage`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            },
            ).then(({ data }) => {
                if (data.status == 'done') {
                    setVoucher(data)
                    message.success(`Archivo subido correctamente`)
    
                }
    
            }).catch(function (error) {
    
                message.error(`Hubo un error al subir el archivo.`)
    
    
            })
        }
        }
       

    function beforeUpload(file) {

        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf'
        if (!isJpgOrPng) {
            message.error('Solo se permiten imagenes o archivos pdf.')
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
            message.error('Tmaño máximo de archivo: 2MB!')
        }
        return isJpgOrPng && isLt2M
    }

    const uploadButton = (
        <div style={{ marginTop: 8, width: '100px !important' }}>
            <label className='label-input-file' for='input-file'>
            <div style={{ marginTop: 8, width: '140px' }} >
                <CloudUploadOutlined /> Subir Voucher
            </div>
            </label>
            <input id='input-file' className='input-file' placeholder='l' onChange={(e) => uploadFile(e)} type='file' style={{ marginTop: 8, width: '100px' }} />
           
        </div>
    )

    const addCourse = (course) => {
        // setLoadingCourse(true)
        onChangePaymentMethod('')
        let a_courses = courses
        let price = 0
        let results = a_courses.filter(function (c) { return c.idProgramming == course.idProgramming; });

        if (results.length == 0) {

            a_courses.push(course)

        } else {

            a_courses = a_courses.filter(function (c) { return c.idProgramming != course.idProgramming; });
        }

        a_courses.map((c) => {
            price = parseFloat(c.price) + parseFloat(price)
        })

        let a_rules = rulesSeguriton.filter(function (c) { return c.amount == a_courses.length; });
        if (a_rules[0]) {
            setDiscount(a_rules[0].discount)
            setTotal((price - a_rules[0].discount))

        } else {
            setDiscount('0.00')
            setTotal((price))

        }
        setCourses([...a_courses])
        coursesRef.current = [...a_courses]
    }

    return (
        <Layout>

            <NavBar />
            {processingPayment && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    textAlign: 'center',
                    padding: '20px'
                }}>
                    <Spin size="large" style={{ marginBottom: '24px' }} />
                    <h2 style={{ color: '#fff', fontSize: '24px', marginBottom: '12px' }}>
                        {processingMessage}
                    </h2>
                    <p style={{ fontSize: '14px', color: '#ddd' }}>
                        Estamos registrando tu inscripción de forma segura.
                    </p>
                </div>
            )}
            {responsive ? null : saveSuccess === 0 ?
                <Content className="site-layout">
                    <Row style={{ marginRight: 'auto', marginLeft: 'auto', justifyContent: 'center' }}>
                        {coursesSeguriton.length > 0 ?
                            <Col lg={16} xs={24} sm={24} md={24} style={{ width: '100%' }}>
                                <Card className='card-info-course gx-card' style={{ marginBottom: '1rem' }}>
                                    <Row >
                                        <Col xs={24} style={{ textAlign: 'center', fontSize: '20px', marginBottom: '10px' }}>  <label className='orange_iteprevengo' ><b>Seleccione los cursos del Seguriton</b></label></Col>

                                        <Col xs={24} >
                                            <table className='table-courses-seguriton' width='100%'>

                                                <tbody>

                                                    {coursesSeguriton.length > 0 ? coursesSeguriton.map((course) => {
                                                        return <tr>

                                                            <td width='60%' ><Checkbox disabled={loadingCourse} onChange={() => addCourse(course)} /> {course.course_name} Modalidad:{course.modality}
                                                            </td>
                                                            <td width='20%' style={{ textAlign: 'center' }}><CalendarFilled />  {course.startDate}  {course.startHour}</td>
                                                            <td width='20%' style={{ textAlign: 'right' }}>S/. {course.price}</td>
                                                        </tr>
                                                    }) : ''}


                                                </tbody>
                                            </table>
                                            <br></br> <br></br>
                                            {loadingCourse ? <Spin color='#072d70' tip="Añadiendo curso..."> </Spin> : ''}
                                            <br></br><br></br>
                                        </Col>


                                    </Row>

                                </Card>
                            </Col> : ''}

                        {!authUser ? (
                                <Col lg={16} xs={24} sm={24} md={24} style={{ width: '100%' }}>
                                    <Card className='card-info-course' style={{ marginBottom: '1rem' }}>
                                        <Row>
                                            <Col xs={24} md={24} style={{ textAlign: 'center', fontSize: '20px', marginBottom: '10px' }}>
                                                <label className='orange_iteprevengo'><b>Datos de Inscripción</b></label>
                                            </Col>

                                            <Col xs={24} md={24} lg={6}>
                                                * <span className='blue_iteprevengo'><b>Tipo de participante</b></span>
                                            </Col>
                                            <Col xs={24} md={24} lg={18}>
                                                <Select
                                                    value={participantType || undefined}
                                                    onChange={onChangeParticipantType}
                                                    style={{ width: '100%' }}
                                                    placeholder='Seleccione una opción'
                                                >
                                                    <Select.Option value="PERSONA_NATURAL">PERSONA NATURAL</Select.Option>
                                                    <Select.Option value="EMPRESA">EMPRESA</Select.Option>
                                                </Select>
                                            </Col>

                                            {participantType === 'PERSONA_NATURAL' && (
                                                <>
                                                    <Col xs={24} style={{ marginTop: '5px' }}></Col>
                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Tipo de documento</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Select value={typeDoc || undefined} onChange={handleChangeTypeDocument} style={{ width: '100%' }}>
                                                            <Select.Option value="DNI">DNI</Select.Option>
                                                            <Select.Option value="PASAPORTE">PASAPORTE</Select.Option>
                                                            <Select.Option value="CARNET">CARNET</Select.Option>
                                                        </Select>
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Nro. de documento</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input
                                                            maxLength={typeDoc === "DNI" ? 8 : 12}
                                                            minLength={typeDoc === "DNI" ? 8 : 5}
                                                            value={nroDoc}
                                                            onChange={handleChangeClientDocument}
                                                        />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Nombres</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input value={namePerson} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setNamePerson(v); namePersonRef.current = v }} />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Apellido Paterno</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input value={lastName1} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setLastName1(v); lastName1Ref.current = v }} />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Apellido Materno</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input value={lastName2} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setLastName2(v); lastName2Ref.current = v }} />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Correo</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input value={email} onChange={(e) => { setEmail(e.target.value); emailRef.current = e.target.value }} />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Celular</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <PhoneInput
                                                            international
                                                            defaultCountry="PE"
                                                            countryCallingCodeEditable={false}
                                                            limitMaxLength
                                                            value={phone}
                                                            onChange={(val) => { setPhone(val); phoneRef.current = val }}
                                                        />
                                                    </Col>
                                                </>
                                            )}

                                            {participantType === 'EMPRESA' && (
                                                <>
                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>RUC</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input
                                                            value={companyRuc}
                                                            maxLength={11}
                                                            onChange={(e) => { const v = e.target.value.replace(/\D/g, ''); setCompanyRuc(v); companyRucRef.current = v }}
                                                        />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Razón social</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input
                                                            value={companyBusinessName}
                                                            onChange={(e) => { setCompanyBusinessName(e.target.value); companyBusinessNameRef.current = e.target.value }}
                                                        />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Correo</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input
                                                            value={companyEmail}
                                                            onChange={(e) => { setCompanyEmail(e.target.value); companyEmailRef.current = e.target.value }}
                                                        />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Persona de contacto</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <Input
                                                            value={companyContactPerson}
                                                            onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setCompanyContactPerson(v); companyContactPersonRef.current = v }}
                                                        />
                                                    </Col>

                                                    <Col xs={24} md={24} lg={6}> * <span className='blue_iteprevengo'><b>Celular</b></span></Col>
                                                    <Col xs={24} md={24} lg={18}>
                                                        <PhoneInput
                                                            international
                                                            defaultCountry="PE"
                                                            countryCallingCodeEditable={false}
                                                            limitMaxLength
                                                            value={companyPhone}
                                                            onChange={(val) => { setCompanyPhone(val); companyPhoneRef.current = val }}
                                                        />
                                                    </Col>
                                                </>
                                            )}

                                            <br></br><br></br>
                                            <Col xs={24} md={24}>
                                                <span><b>Nota 1:</b> Verifique que sus datos sean correctos, a partir de ellos se le emitirá el certificado.</span> <br></br>
                                                <span><b>Nota 2:</b> En caso deseas más de una vacante por curso, luego de validar tu inscripción nos contactaremos contigo para solicitar los datos de los inscritos.</span>
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <span><b>Datos requeridos (*).</b></span>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            ) : ''}

                        <Col lg={16} xs={24} sm={24} md={24} style={{ width: '100%' }}>
                            <Card className='card-info-course gx-card' style={{ marginBottom: '1rem' }}>
                                <Row >
                                    <Col xs={24} style={{ textAlign: 'center', fontSize: '20px', marginBottom: '10px' }}>  <label className='orange_iteprevengo' ><b>Detalle del pedido (¿Cuánto Pagarás?)</b></label></Col>
                                        <Col xs={24} style={{ marginBottom: '12px' }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                background: 'var(--orange)',
                                                color: '#072d70',
                                                padding: '10px 18px',
                                                borderRadius: '8px',
                                                fontSize: '0.95rem',
                                                fontWeight: '600',
                                                boxShadow: '0 3px 10px rgba(26, 58, 107, 0.18)'
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                                    <line x1="7" y1="7" x2="7.01" y2="7"></line>
                                                </svg>
                                                <span>
                                                    10% de descuento inscribiendo a <strong>2 o más personas en un mismo curso</strong>
                                                    {' | '}
                                                    15% de descuento al inscribirte en <strong>más de 1 curso</strong>
                                                </span>
                                            </div>

                                            <div style={{ marginTop: '8px', fontSize: '12px', color: '#696868', lineHeight: '1.6', padding: '0 4px' }}>
                                                <strong>¿Cómo funcionan los descuentos?</strong><br />
                                                • Si agregas <strong>1 curso</strong> con cantidad <strong>2 o más personas</strong>: se aplica un <strong>10% de descuento</strong> sobre el total.<br />
                                                • Si agregas <strong>2 o más cursos distintos</strong>: se aplica un <strong>15% de descuento</strong> sobre el total, sin importar la cantidad de personas por curso.<br />
                                                • Si se cumplen ambas condiciones a la vez (varios cursos y varios participantes), <strong>siempre gana el 15%</strong> por ser el descuento más beneficioso para ti.<br />
                                                • Los descuentos <strong>no son acumulables</strong> entre sí.
                                            </div>
                                        </Col>
                                    <Col xs={24} >
                                        <table className='table-payment' width='100%'>


                                            <thead>
                                                <tr>
                                                    <td width='55%'>Cursos</td>
                                                    <td width='15%'>Cant.</td>
                                                    <td width='20%'>Precio</td>
                                                    <td width='10%'>Eliminar</td>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {courses.length > 0 ? courses.map((course, index) => {
                                                    const qty = course.qty || 1
                                                    const unitPrice = parseFloat(course.price || 0)
                                                    const totalPrice = unitPrice * qty

                                                    return (
                                                        <tr key={`${course.idProgramming}-${index}`}>
                                                            <td width='55%'>
                                                                {course.course_name} Modalidad:{course.modality}
                                                            </td>
                                                            <td width='15%' style={{ textAlign: 'center' }}>
                                                                <InputNumber
                                                                    min={1}
                                                                    value={qty}
                                                                    onChange={(value) => updateCourseQty(index, value)}
                                                                />
                                                            </td>
                                                            <td width='20%' style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                                                S/. {totalPrice.toFixed(2)}
                                                            </td>
                                                            <td width='10%' style={{ textAlign: 'center' }}>
                                                                {courses.length > 1 ? (
                                                                    <Button
                                                                        danger
                                                                        type="text"
                                                                        icon={<DeleteOutlined />}
                                                                        onClick={() => removeSelectedCourse(course)}
                                                                    />
                                                                ) : null}
                                                            </td>
                                                        </tr>
                                                    )
                                                }) : ''}
                                            </tbody>
                                        </table>
                                    </Col>


                                    <Col xs={24} style={{ justifyContent: 'right' }}>
                                        <br />
                                        <table style={{ textAlign: 'right' }} width='100%'>
                                            <tbody>
                                                {parseFloat(discount) > 0 && (
                                                    <>
                                                        <tr>
                                                            <td width='60%'>
                                                                <p style={{ fontSize: '15px' }}><b>Subtotal:</b></p>
                                                            </td>
                                                            <td width='40%'>
                                                                <p style={{ fontSize: '15px' }}><b>S/. {subtotal.toFixed(2)}</b></p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width='60%'>
                                                                <p style={{ fontSize: '15px', color: '#e63946' }}>
                                                                    <b>Descuento ({getDiscountRate(courses) * 100}%):</b>
                                                                </p>
                                                            </td>
                                                            <td width='40%'>
                                                                <p style={{ fontSize: '15px', color: '#e63946' }}>
                                                                    <b>- S/. {discount}</b>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}
                                                <tr>
                                                    <td width='60%'>
                                                        <p style={{ fontSize: '18px' }}><b>Total:</b></p>
                                                    </td>
                                                    <td width='40%'>
                                                        <p style={{ fontSize: '18px' }}><b>S/. {(total * 1).toFixed(2)}</b></p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Col>

                                    <Col xs={24} style={{ textAlign: 'center', marginTop: '15px' }}>
                                        <Button
                                            onClick={() => setShowMoreCoursesTable(!showMoreCoursesTable)}
                                            className='btn-blue-iteprevengo'
                                        >
                                            {showMoreCoursesTable ? 'Ocultar cursos' : 'Mostrar más cursos'}
                                        </Button>
                                    </Col>

                                    {showMoreCoursesTable && (
                                        <Col xs={24} style={{ marginTop: '20px' }}>
                                            <table className='table-payment' width='100%'>
                                                <thead>
                                                    <tr>
                                                        <td width='55%'>Nombre del Curso</td>
                                                        <td width='15%'>Precio</td>
                                                        <td width='15%'>Horas</td>
                                                        <td width='15%'>Agregar</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {availableCourses.length > 0 ? (
                                                        availableCourses.map((course, index) => (
                                                            <tr key={`${course.idProgramming}-available-${index}`}>
                                                                <td>{course.course_name}</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    S/. {parseFloat(course.price || 0).toFixed(2)}
                                                                </td>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    {course.duration}h
                                                                </td>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <Button
                                                                        className='btn-blue-iteprevengo'
                                                                        onClick={() => addAvailableCourse(course)}
                                                                    >+</Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" style={{ textAlign: 'center' }}>
                                                                No hay más cursos disponibles para añadir
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </Col>
                                    )}

                                    <Col xs={24} style={{ textAlign: 'center',display:'none' }}> <br></br>  <img className='logo-cards' src={logosCards} /> </Col>
                                    <Col xs={24} >
                                        <br></br>
                                        <p><QuestionCircleOutlined />Pago en soles (S/.) correspondiente a Perú. </p>

                                    </Col>
                                </Row>




                            </Card>
                        </Col>

                        {(programmingData.participantPrice === "0.00" || programmingData.participantPrice === "GRATUITO") ? null :
                            <>
                                {/* Comentamos la vista de elección de comprobante */}
                                {/* <Col lg={16} xs={24} sm={24} md={24} style={{ width: '100%' }}>
                                    <Card className='card-info-course gx-card' style={{ marginBottom: '1rem' }}>
                                        <Row >
                                            <Col xs={24} style={{ textAlign: 'center', fontSize: '20px', marginBottom: '10px' }}>  <label className='orange_iteprevengo' ><b>Comprobante</b></label></Col>
                                            <Col xs={24} lg={24} style={{ textAlign: 'center', padding: '8x 0 18px 0' }}>
                                                <Radio.Group
                                                    options={optionsPaymentMethod}
                                                    onChange={(e) => setVoucherType(e.target.value)}
                                                    optionType="button"
                                                    buttonStyle="solid"
                                                    value={voucherType}
                                                />

                                            </Col>
                                            <Col xs={24} style={voucherType == 'INVOICE' ? { display: "none" } : {}} >
                                                <br></br>
                                                <span><b>Nota:</b> Se emitirá su boleta con sus datos ingresados.</span></Col>

                                            <Col xs={6} style={voucherType != 'INVOICE' ? { display: "none" } : {}} > <span className='blue_iteprevengo' ><b>Ruc</b></span></Col>
                                            <Col xs={18} style={voucherType != 'INVOICE' ? { display: "none" } : {}} > <Input size='' value={invoiceRuc} onChange={(e) => setInvoiceRuc(e.target.value.replace(/\D/, ''))} maxLength='12' /></Col>
                                            <Col xs={6} style={voucherType != 'INVOICE' ? { display: "none" } : {}}> <span className='blue_iteprevengo' ><b>Rázon social</b></span></Col>
                                            <Col xs={18} style={voucherType != 'INVOICE' ? { display: "none" } : {}} > <Input size='' onChange={(e) => setInvoiceBusinessName(e.target.value)} /></Col>

                                        </Row>

                                    </Card>
                                </Col> */}

                                <Col lg={16} xs={24} sm={24} md={24} style={{ width: '100%' }}>
                                    <Card className='card-payment' style={{ marginBottom: '1rem' }}>
                                        <Row>
                                            <Col xs={24} style={{ textAlign: 'center', fontSize: '20px', marginBottom: '10px' }}>
                                                <label className='orange_iteprevengo'><b>Método de pago seguro</b></label>
                                            </Col>
                                            <Col xs={24}>
                                                {total > 0 ? (
                                                    <>
                                                        <p style={{ textAlign: 'center', fontSize: '16px', marginBottom: '8px' }}>
                                                            <b>Total a pagar: S/. {total.toFixed(2)}</b>
                                                        </p>
                                                        <MercadoPagoBrick
                                                            amount={parseFloat(total.toFixed(2))}
                                                            onSuccess={onMPSuccess}
                                                            onError={onMPError}
                                                            onBeforeSubmit={validate}
                                                        />
                                                    </>
                                                ) : (
                                                    <p style={{ textAlign: 'center' }}>Seleccione al menos un curso para continuar.</p>
                                                )}
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>    
                                
                            </>
                        }
                        <Col xs={24} style={{ textAlign: 'center' }}>
                            <br></br>
                            <Checkbox checked={checkTerms} onChange={(e) => {
                                    setCheckTerms(e.target.checked)
                                    checkTermsRef.current = e.target.checked
                                }} style={{ fontSize: '1rem' }}>
                                Acepto los  <a target='_blank' href='https://gestionasst.pe/terminos.php'>términos y condiciones.</a>
                            </Checkbox>

                        </Col>

                        
                    </Row>

                                


                </Content>
                :
                <Content className="site-layout">
                    <Row style={responsive ? { width: '100%' } : { marginRight: 'auto', marginLeft: 'auto', width: '60%' }}>
                        <Col lg={23} xs={24} style={{ width: '100%' }}>
                            <Card className='card-info-course gx-card' style={{ marginBottom: '1rem', textAlign: 'center' }}>
                                <img src={checkedSVG} width="100" />
                                <h3 className="orange_iteprevengo">{saveSuccessData.text1}</h3>
                                {saveSuccessData.text2 ? <p className="blue_iteprevengo"><CheckCircleOutlined className="orange_iteprevengo" /> {saveSuccessData.text2}</p> : null}
                                <br></br>
                                {saveSuccessData.text3 ? <p><MailFilled className="blue_iteprevengo" /> {saveSuccessData.text3}</p> : null}
                                <br></br>
                                {typePayment == 'NIUBIZ' ?
                                    <>
                                        <Row>
                                            <Col xs={24} >
                                                <br></br>

                                                <table className='table-payment-data' style={{ textAlign: 'left' }} width='100%'>

                                                    <tbody>

                                                        <tr  >
                                                            <td width='70%' style={{ padding: '5px' }}><p><b>N° de pedido:</b></p></td>
                                                            <td width='30%' style={{ textAlign: 'right' }} > <p><b>  {(saveSuccessData.purchaseNumber)} </b> </p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td width='70%' style={{ padding: '5px' }} ><p><b>N° de tarjeta:</b></p></td>
                                                            <td width='30%' style={{ textAlign: 'right' }} > <p><b>  {(saveSuccessData.card)} </b> </p>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                                <br></br><br></br>
                                            </Col>
                                            {/* <Col xs={24} >
                                                <p style={{ textAlign: 'left', fontSize: '18px' }}> <b>Cursos:</b></p>

                                                <table className='table-payment' style={{ fontSize: '13px ' }} width='100%'>

                                                    <tbody>

                                                        {courses.length > 0 ? courses.map((course) => {
                                                            return <tr>
                                                                <td width='70%' style={{ textAlign: 'left' }}>{course.course_name} Modalidad:{course.modality}
                                                                </td>
                                                                <td width='30%' style={{ textAlign: 'right' }}>S/. {course.price}</td>
                                                            </tr>
                                                        }) : ''}

                                                    </tbody>
                                                </table>
                                            </Col> */}
                                            <Col xs={24} style={{ justifyContent: 'right' }}>
                                                <br></br>

                                                <table style={{ textAlign: 'right' }} width='100%'>

                                                    <tbody>
                                                        {/* <tr>
                                                            <td width='60%' ><p><b>Descuento: </b></p></td>
                                                            <td width='10%' ><p><b>S/. {saveSuccessData.discount}</b> </p></td>
                                                        </tr>
                                                        <tr>
                                                            <td width='80%' ><p><b>Subtotal: </b></p></td>
                                                            <td width='20%' ><p><b>S/. {saveSuccessData.subtotal}</b> </p></td>
                                                        </tr>

                                                        <tr>
                                                            <td width='80%' ><p><b>IGV(%18):</b></p></td>
                                                            <td width='20%' ><p><b>S/. {(saveSuccessData.igv)}</b> </p></td>
                                                        </tr> */}

                                                        <tr>
                                                            <td width='80%' ><p><b>Total:</b></p></td>
                                                            <td width='20%' > <p><b> S/. {(saveSuccessData.total)} </b> </p>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </Col>
                                            <Col xs={24}>
                                                <br></br>
                                                Le invitamos a ver nuestros términos y condiciones de pago  <a target='_blank' href='https://gestionasst.pe/terminos.php'>aquí</a>

                                            </Col>

                                        </Row>

                                        <br></br>

                                        <Button onClick={() => window.open(saveSuccessData.url_pdf)} icon={<DownloadOutlined />} className='btn-blue-iteprevengo'>Descargar pago</Button>
                                        <br></br>
                                    </>
                                    :
                                    ''}
                                {/* <Link to="/Login">
                                    <button className="btn-orange-iteprevengo">Ingresar al aula virtual</button>
                                </Link> */}
                            </Card>
                        </Col>
                    </Row>
                </Content>}

            {/* ── VISTA MOBILE ─────────────────────────────────────────── */}
            {responsive && saveSuccess === 0 && (
                <Content style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', paddingBottom: '24px' }}>

                    {/* Breadcrumb */}
                    <div style={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        padding: '10px 16px', backgroundColor: '#fff',
                        borderBottom: '1px solid #e8e8e8', fontSize: '13px', gap: '6px'
                    }}>
                        <span
                            style={{ color: mobileStep === 'datos' ? '#072d70' : '#999', fontWeight: mobileStep === 'datos' ? 'bold' : 'normal', cursor: mobileStep === 'pago' ? 'pointer' : 'default' }}
                            onClick={() => mobileStep === 'pago' && setMobileStep('datos')}
                        >[ Datos ]</span>
                        <span style={{ color: '#bbb' }}>→</span>
                        <span style={{ color: mobileStep === 'pago' ? '#072d70' : '#999', fontWeight: mobileStep === 'pago' ? 'bold' : 'normal' }}>[ Pago ]</span>
                    </div>

                    <div style={{ padding: '16px' }}>
                        {mobileStep === 'datos' ? (
                            <>
                                {/* Resumen del Pedido */}
                                <h3 style={{ textAlign: 'center', color: '#072d70', fontWeight: 'bold', marginBottom: '14px', fontSize: '18px' }}>
                                    Resumen del Pedido
                                </h3>

                                {/* Banner de descuento */}
                                {courses.length > 0 && (
                                    <div style={{
                                        background: 'var(--orange)', color: '#072d70', padding: '10px 14px',
                                        borderRadius: '8px', fontSize: '13px', fontWeight: '600',
                                        marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px'
                                    }}>
                                        <TagFilled />
                                        <span>
                                            {getDiscountRate(courses) > 0
                                                ? `¡Tienes un ${getDiscountRate(courses) * 100}% de descuento aplicado!`
                                                : courses.length === 1
                                                    ? '¡Agrega 1 curso más para un 15% de descuento!'
                                                    : ''}
                                        </span>
                                    </div>
                                )}

                                {/* Cards de cursos seleccionados */}
                                {courses.map((course, index) => {
                                    const qty = course.qty || 1
                                    const unitPrice = parseFloat(course.price || 0)
                                    return (
                                        <div key={`mob-${course.idProgramming}-${index}`} style={{
                                            background: '#fff', borderRadius: '10px', padding: '14px',
                                            marginBottom: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div style={{ flex: 1, paddingRight: '8px' }}>
                                                    <div style={{ fontWeight: 'bold', color: '#072d70', fontSize: '14px', lineHeight: '1.4', marginBottom: '4px' }}>
                                                        {course.course_name}
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#666' }}>
                                                        Modalidad:{course.modality}
                                                    </div>
                                                    {course.duration && (
                                                        <div style={{ fontSize: '12px', color: '#666' }}>
                                                            Duración: {course.duration}h
                                                        </div>
                                                    )}
                                                </div>
                                                <div style={{ fontWeight: 'bold', color: '#072d70', fontSize: '15px', whiteSpace: 'nowrap' }}>
                                                    S/. {(unitPrice * qty).toFixed(2)}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #d9d9d9', borderRadius: '6px', overflow: 'hidden' }}>
                                                    <button
                                                        style={{ width: '32px', height: '32px', border: 'none', background: '#f0f0f0', cursor: 'pointer', fontSize: '18px', lineHeight: 1 }}
                                                        onClick={() => updateCourseQty(index, Math.max(1, qty - 1))}
                                                    >−</button>
                                                    <span style={{ width: '36px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold' }}>{qty}</span>
                                                    <button
                                                        style={{ width: '32px', height: '32px', border: 'none', background: '#f0f0f0', cursor: 'pointer', fontSize: '18px', lineHeight: 1 }}
                                                        onClick={() => updateCourseQty(index, qty + 1)}
                                                    >+</button>
                                                </div>
                                                {courses.length > 1 && (
                                                    <Button danger type="text" icon={<DeleteOutlined />} onClick={() => removeSelectedCourse(course)} style={{ fontSize: '13px' }}>
                                                        Eliminar
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}

                                {/* Toggle cursos disponibles */}
                                <Button
                                    block
                                    onClick={() => setShowMoreCoursesTable(!showMoreCoursesTable)}
                                    style={{ backgroundColor: '#072d70', borderColor: '#072d70', color: '#fff', borderRadius: '8px', marginBottom: '12px', boxShadow: '0 4px 14px rgba(242, 147, 20, 0.6), 0 2px 6px rgba(242, 147, 20, 0.4)' }}
                                >
                                    {showMoreCoursesTable ? 'Ocultar cursos' : '+ Aprovecha el descuento y adiciona más cursos'}
                                </Button>
                                <br /> <br /> 
                                {/* Lista de cursos disponibles */}
                                {showMoreCoursesTable && (
                                    <div style={{ marginBottom: '12px', maxHeight: '365px', overflowY: 'auto', border: '1.5px solid var(--orange)', borderRadius: '10px', padding: '10px' }}>
                                        {availableCourses.length > 0 ? availableCourses.map((course, index) => (
                                            <div key={`mob-avail-${course.idProgramming}-${index}`} style={{
                                                background: '#fff', borderRadius: '10px', padding: '12px 14px',
                                                marginBottom: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.07)',
                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                                            }}>
                                                <div style={{ flex: 1, paddingRight: '10px' }}>
                                                    <div style={{ fontWeight: '600', color: '#333', fontSize: '13px', marginBottom: '2px' }}>{course.course_name}</div>
                                                    <div style={{ fontSize: '11px', color: '#888' }}>Modalidad:{course.modality}</div>
                                                    {course.duration && (
                                                        <div style={{ fontSize: '11px', color: '#888' }}>Duración: {course.duration}h</div>
                                                    )}
                                                    <div style={{ fontWeight: 'bold', color: '#072d70', fontSize: '13px', marginTop: '2px' }}>
                                                        S/. {parseFloat(course.price || 0).toFixed(2)}
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => addAvailableCourse(course)}
                                                    style={{
                                                        width: '36px', height: '36px', borderRadius: '50%',
                                                        background: '#072d70', border: 'none', color: '#fff',
                                                        fontSize: '22px', cursor: 'pointer', display: 'flex',
                                                        alignItems: 'center', justifyContent: 'center', flexShrink: 0
                                                    }}
                                                >+</button>
                                            </div>
                                        )) : (
                                            <p style={{ textAlign: 'center', color: '#999', fontSize: '13px', padding: '12px' }}>
                                                No hay más cursos disponibles para añadir
                                            </p>
                                        )}
                                    </div>
                                )}

                                {/* Total */}
                                <div style={{
                                    background: '#fff', borderRadius: '10px', padding: '14px',
                                    marginBottom: '14px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                }}>
                                    {parseFloat(discount) > 0 && (
                                        <>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
                                                <span>Subtotal:</span><span>S/. {subtotal.toFixed(2)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#e63946', marginBottom: '6px' }}>
                                                <span>Descuento ({getDiscountRate(courses) * 100}%):</span><span>- S/. {discount}</span>
                                            </div>
                                        </>
                                    )}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#333' }}>Total a pagar:</span>
                                        <span style={{ fontSize: '22px', fontWeight: 'bold', color: '#072d70' }}>S/. {(total * 1).toFixed(2)}</span>
                                    </div>
                                    <div style={{ marginTop: '8px', fontSize: '11px', color: '#888', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <span>🔒</span><span>Pago 100% Seguro · VISA · Mastercard · Diners</span>
                                    </div>
                                </div>

                                {/* Datos de Inscripción */}
                                {!authUser && (
                                    <div style={{
                                        background: '#fff', borderRadius: '10px', padding: '16px',
                                        marginBottom: '14px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                    }}>
                                        <h4 style={{ textAlign: 'center', color: 'var(--orange)', fontWeight: 'bold', marginBottom: '14px', fontSize: '16px' }}>
                                            Datos de Inscripción
                                        </h4>

                                        {/* Tabs Persona Natural / Empresa */}
                                        <div style={{ display: 'flex', border: '1px solid #072d70', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                            <button
                                                onClick={() => onChangeParticipantType('PERSONA_NATURAL')}
                                                style={{
                                                    flex: 1, padding: '10px', border: 'none', cursor: 'pointer',
                                                    background: participantType === 'PERSONA_NATURAL' ? '#072d70' : '#fff',
                                                    color: participantType === 'PERSONA_NATURAL' ? '#fff' : '#072d70',
                                                    fontWeight: 'bold', fontSize: '13px'
                                                }}
                                            >SOY Persona Natural</button>
                                            <button
                                                onClick={() => onChangeParticipantType('EMPRESA')}
                                                style={{
                                                    flex: 1, padding: '10px', border: 'none', borderLeft: '1px solid #072d70', cursor: 'pointer',
                                                    background: participantType === 'EMPRESA' ? '#072d70' : '#fff',
                                                    color: participantType === 'EMPRESA' ? '#fff' : '#072d70',
                                                    fontWeight: 'bold', fontSize: '13px'
                                                }}
                                            >SOY Empresa</button>
                                        </div>

                                        {/* Campos Persona Natural */}
                                        {participantType === 'PERSONA_NATURAL' && (
                                            <>
                                                <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Tipo de documento</label>
                                                        <Select value={typeDoc || undefined} onChange={handleChangeTypeDocument} style={{ width: '100%' }} placeholder='Tipo'>
                                                            <Select.Option value="DNI">DNI</Select.Option>
                                                            <Select.Option value="PASAPORTE">PASAPORTE</Select.Option>
                                                            <Select.Option value="CARNET">CARNET</Select.Option>
                                                        </Select>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Número de documento</label>
                                                        <Input maxLength={typeDoc === "DNI" ? 8 : 12} value={nroDoc} onChange={handleChangeClientDocument} placeholder='Nro.' />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Nombres</label>
                                                    <Input value={namePerson} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setNamePerson(v); namePersonRef.current = v }} placeholder='Nombres' />
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Apellido Paterno</label>
                                                    <Input value={lastName1} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setLastName1(v); lastName1Ref.current = v }} placeholder='Apellido Paterno' />
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Apellido Materno</label>
                                                    <Input value={lastName2} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setLastName2(v); lastName2Ref.current = v }} placeholder='Apellido Materno' />
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Correo electrónico</label>
                                                    <Input value={email} onChange={(e) => { setEmail(e.target.value); emailRef.current = e.target.value }} placeholder='correo@ejemplo.com' type='email' />
                                                </div>
                                                <div style={{ marginBottom: '8px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Celular</label>
                                                    <PhoneInput international defaultCountry="PE" countryCallingCodeEditable={false} limitMaxLength value={phone} onChange={(val) => { setPhone(val); phoneRef.current = val }} />
                                                </div>
                                            </>
                                        )}

                                        {/* Campos Empresa */}
                                        {participantType === 'EMPRESA' && (
                                            <>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>RUC</label>
                                                    <Input value={companyRuc} maxLength={11} onChange={(e) => { const v = e.target.value.replace(/\D/g, ''); setCompanyRuc(v); companyRucRef.current = v }} placeholder='RUC (11 dígitos)' />
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Razón social</label>
                                                    <Input value={companyBusinessName} onChange={(e) => { setCompanyBusinessName(e.target.value); companyBusinessNameRef.current = e.target.value }} placeholder='Razón social' />
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Correo</label>
                                                    <Input value={companyEmail} onChange={(e) => { setCompanyEmail(e.target.value); companyEmailRef.current = e.target.value }} placeholder='correo@empresa.com' />
                                                </div>
                                                <div style={{ marginBottom: '12px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Persona de contacto</label>
                                                    <Input value={companyContactPerson} onChange={(e) => { const v = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, ''); setCompanyContactPerson(v); companyContactPersonRef.current = v }} placeholder='Nombre del contacto' />
                                                </div>
                                                <div style={{ marginBottom: '8px' }}>
                                                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Celular</label>
                                                    <PhoneInput international defaultCountry="PE" countryCallingCodeEditable={false} limitMaxLength value={companyPhone} onChange={(val) => { setCompanyPhone(val); companyPhoneRef.current = val }} />
                                                </div>
                                            </>
                                        )}

                                        {/* Info certificados (colapsable) */}
                                        {participantType && (
                                            <div style={{ marginTop: '12px', borderTop: '1px solid #f0f0f0', paddingTop: '10px' }}>
                                                <button
                                                    onClick={() => setMobileShowCertInfo(!mobileShowCertInfo)}
                                                    style={{ background: 'none', border: 'none', color: '#072d70', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', padding: 0 }}
                                                >
                                                    {mobileShowCertInfo ? <UpOutlined /> : <DownOutlined />}
                                                    Ver información importante
                                                </button>
                                                {mobileShowCertInfo && (
                                                    <div style={{ marginTop: '8px', fontSize: '12px', color: '#666', background: '#f9f9f9', borderRadius: '6px', padding: '10px' }}>
                                                        <strong>Nota 1:</strong> Verifique que sus datos sean correctos, a partir de ellos se le emitirá el certificado.<br />
                                                        <strong>Nota 2:</strong> En caso deseas más de una vacante por curso, te llegará un correo con un excel para que completes los datos de los participantes y nos lo reenvíes.<br />
                                                        <strong>¿Cómo funcionan los descuentos?</strong><br />
                                                        • Si agregas 1 curso con cantidad 2 o más personas: se aplica un 10% de descuento sobre el total.<br />
                                                        • Si agregas 2 o más cursos distintos: se aplica un 15% de descuento sobre el total, sin importar la cantidad de personas por curso.<br />
                                                        • Si se cumplen ambas condiciones a la vez (varios cursos y varios participantes), siempre gana el 15% por ser el descuento más beneficioso para ti.<br />
                                                        • Los descuentos no son acumulables entre sí.<br />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Botón Proceder al Pago */}
                                <Button
                                    type="primary" block size="large"
                                    style={{ background: '#072d70', borderColor: '#072d70', borderRadius: '10px', height: '50px', fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}
                                    onClick={() => {
                                        const err = validateDatos()
                                        if (err === '') {
                                            setMobileStep('pago')
                                            window.scrollTo(0, 0)
                                        }
                                    }}
                                >
                                    Proceder al Pago
                                </Button>

                                <p style={{ textAlign: 'center', fontSize: '12px', color: '#aaa', marginTop: '6px' }}>
                                    © Pago en soles (S/.) correspondiente a Perú
                                </p>
                            </>
                        ) : (
                            /* ── STEP PAGO ──────────────────────────────── */
                            <>
                                <h3 style={{ textAlign: 'center', color: '#072d70', fontWeight: 'bold', marginBottom: '6px', fontSize: '18px' }}>
                                    Método de pago seguro
                                </h3>
                                <p style={{ textAlign: 'center', fontSize: '15px', marginBottom: '16px', color: '#333' }}>
                                    <b>Total a pagar: S/. {total.toFixed(2)}</b>
                                </p>

                                <div style={{ background: '#fff', borderRadius: '10px', padding: '16px', marginBottom: '14px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                                    {total > 0 ? (
                                        <MercadoPagoBrick
                                            amount={parseFloat(total.toFixed(2))}
                                            onSuccess={onMPSuccess}
                                            onError={onMPError}
                                            onBeforeSubmit={validate}
                                        />
                                    ) : (
                                        <p style={{ textAlign: 'center', color: '#999' }}>Seleccione al menos un curso para continuar.</p>
                                    )}
                                </div>

                                {/* Términos */}
                                <div style={{ textAlign: 'center', marginBottom: '14px' }}>
                                    <Checkbox
                                        checked={checkTerms}
                                        onChange={(e) => { setCheckTerms(e.target.checked); checkTermsRef.current = e.target.checked }}
                                        style={{ fontSize: '13px' }}
                                    >
                                        Acepto los <a target='_blank' href='https://gestionasst.pe/terminos.php'>términos y condiciones.</a>
                                    </Checkbox>
                                </div>

                                {/* Botón Volver */}
                                <Button
                                    block size="large"
                                    style={{ borderColor: '#072d70', color: '#072d70', borderRadius: '10px', height: '46px', fontSize: '15px' }}
                                    onClick={() => { setMobileStep('datos'); window.scrollTo(0, 0) }}
                                >
                                    Volver
                                </Button>
                            </>
                        )}
                    </div>
                </Content>
            )}

            {/* Success screen mobile*/}
            {responsive && saveSuccess === 1 && (
                <Content className="site-layout">
                    <Row style={{ width: '100%' }}>
                        <Col xs={24} style={{ width: '100%' }}>
                            <Card className='card-info-course gx-card' style={{ marginBottom: '1rem', textAlign: 'center' }}>
                                <img src={checkedSVG} width="80" />
                                <h3 className="orange_iteprevengo">{saveSuccessData.text1}</h3>
                                {saveSuccessData.text2 ? <p className="blue_iteprevengo"><CheckCircleOutlined className="orange_iteprevengo" /> {saveSuccessData.text2}</p> : null}
                                <br />
                                {saveSuccessData.text3 ? <p><MailFilled className="blue_iteprevengo" /> {saveSuccessData.text3}</p> : null}
                            </Card>
                        </Col>
                    </Row>
                </Content>
            )}
            {/* ── FIN VISTA MOBILE ─────────────────────────────────────── */}

            <Footer style={{ textAlign: 'center' }}>© {brand.name} 2026</Footer>
        </Layout>
    );
};

const Inscription = () => (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
        <InscriptionInner />
    </GoogleReCaptchaProvider>
);

export default Inscription;